module.exports = __webpack_public_path__ + "static/img/1.2031b11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/1.png
// module id = peIR
// module chunks = 0